import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class TokenProvider {
	token : string;

  constructor(public http: HttpClient) {
    console.log('Hello TokenProvider Provider');
  }

  // function getUserToken() {
  // 	return this.token;
  // }

  // function setUserToken(token:string) {
  // 	this.token = token;
  // }
}



// WEBPACK FOOTER //
// ./src/providers/token/token.ts